import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'base-toast',
    template: ``,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export abstract class BaseToastComponent  {
  @Input() isOpen: boolean;
  @Output() close: EventEmitter<any> = new EventEmitter();

  onClose(data?: any) {
    this.isOpen = false;
    this.close.emit(data);
  }
}
